<main class="main-wrap-ng">
  <div class="content-blk edit-store dv-edt-str">
    <div class="container">
      <h5 class="page-title">
        Edit Store Information
      </h5>
      <form [formGroup]="editStoreForm">
        <div class="store-set-blk">
          <div class="store-set-ui">
            <div class="row">
              <!-- STORE NAME AND DESCRIPTION-->
              <div class="col-lg-6 mat-crd-ui">
                <mat-card>
                  <mat-card-title>
                    <h5 class="page-title">
                      Store name and description
                    </h5>
                  </mat-card-title>
                  <mat-card-content>
                    <div class="example-form">
                      <div class="row">
                        <div class="col-sm-12">
                          <mat-form-field class="example-full-width">
                            <mat-label>Store Name</mat-label>
                            <input matInput placeholder="Store Name" formControlName="StoreName">
                            <mat-error>
                              <strong>Required</strong>
                            </mat-error>
                          </mat-form-field>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-12">
                          <mat-form-field class="example-full-width">
                            <mat-label>Store Url</mat-label>
                            <input matInput placeholder="Store Url" [disabled]="true" formControlName="StoreUrl">
                            <mat-error>
                              <strong>Invalid URL</strong>
                            </mat-error>
                          </mat-form-field>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-12">
                          <mat-form-field class="example-full-width">
                            <mat-label>Description</mat-label>
                            <textarea matInput placeholder="Description" formControlName="Description"></textarea>
                            <mat-error>
                              <strong>Required</strong>
                            </mat-error>
                          </mat-form-field>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-12" style="display: flex;">
                          <mat-form-field class="example-full-width">
                            <mat-label>shopify app - api key</mat-label>
                            <input matInput placeholder="shopify app - api key" [disabled]="true" formControlName="apiKey">
                            <mat-error>
                              <strong>Invalid URL</strong>
                            </mat-error>
                          </mat-form-field>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-12">
                          <mat-form-field>
                          <mat-label>Select Category</mat-label>
                          <mat-select  formControlName="StoreCategoryMappings">
                            <mat-option *ngFor="let category of storeCategories" [value]="category.StoreCategoryId">
                              {{category.Name}}
                            </mat-option>
                            <!--<mat-option (click)="fn_AddCategory()">Others</mat-option>-->
                          </mat-select>
                        </mat-form-field>
                        </div>
                      </div>

                    </div>

                  </mat-card-content>
                </mat-card>
              </div>
              <!-- CONTACT IONFORMATION-->
              <div class="col-lg-6 mat-crd-ui">
                <mat-card>
                  <mat-card-title>
                    <h5 class="page-title">
                      Contact Information
                    </h5>
                  </mat-card-title>
                  <mat-card-content>
                    <div class="example-form">
                      <div class="row">
                        <div class="col-sm-6">
                          <mat-form-field class="example-full-width">
                            <mat-label>Contact Name</mat-label>
                            <input matInput placeholder="Contact Name" formControlName="ContactPersonName">
                          </mat-form-field>
                        </div>
                        <div class="col-sm-6">
                          <mat-form-field class="example-full-width">
                            <mat-label>Contact Number</mat-label>
                            <input matInput placeholder="Contact Number" formControlName="ContactNumber">
                            <mat-error>
                              <strong>Expect only numbers </strong>
                            </mat-error>
                          </mat-form-field>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-6">
                          <mat-form-field class="example-full-width">
                            <mat-label>Email</mat-label>
                            <input matInput placeholder="Email" formControlName="ContactEmail">
                            <mat-error>
                              <strong>Invalid Email Address</strong>
                            </mat-error>
                          </mat-form-field>
                        </div>
                        <div class="col-sm-6">
                          <mat-form-field >
                          <mat-label>Country</mat-label>
                          <mat-select  formControlName="CountryId" (selectionChange)="getStatesByCountry($event.value)">
                            <mat-option *ngFor="let country of countries" [value]="country.Value">
                              {{country.Text}}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-12">
                          <mat-form-field class="example-full-width">
                            <mat-label>AddressLine 1</mat-label>
                            <input matInput placeholder="AddressLine 1" formControlName="AddressLine1">
                          </mat-form-field>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-12">
                          <mat-form-field class="example-full-width">
                            <mat-label>AddressLine 2</mat-label>
                            <input matInput placeholder="AddressLine 2" formControlName="AddressLine2">
                          </mat-form-field>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-6">
                          <mat-form-field >
                          <mat-label>State</mat-label>
                          <mat-select  formControlName="StateId">
                            <mat-option *ngFor="let state of states" [value]="state.Value">
                              {{state.Text}}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                        </div>
                        <div class="col-sm-6">
                          <mat-form-field class="example-full-width">
                            <mat-label>City</mat-label>
                            <input matInput placeholder="City" formControlName="City">
                          </mat-form-field>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-6">
                          <mat-form-field class="example-full-width">
                            <mat-label>ZipCode</mat-label>
                            <input matInput placeholder="ZipCode" formControlName="PinCode">
                          </mat-form-field>
                        </div>
                        <!-- <div class="col-sm-6">
                          <mat-form-field class="example-full-width">
                              <input matInput placeholder="Landmark" formControlName="Landmark">
                          </mat-form-field>
                        </div>     -->
                      </div>
                    </div>
                  </mat-card-content>
                </mat-card>
              </div>
            </div>
            <div class="row">
              <!-- SOCIAL SETTING -->
              <div class="col-lg-6 mat-crd-ui">
                <mat-card>
                  <mat-card-title>
                    <h5 class="page-title">
                      Social Media
                    </h5>
                  </mat-card-title>
                  <mat-card-content>
                    <ul class="set-social">
                      <li class="fbclr">
                        <a href="javascript:void(0);">
                          <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="20" height="20" viewBox="0 0 430.113 430.114" style="enable-background:new 0 0 430.113 430.114;" xml:space="preserve"><g>
                          <path id="Facebook" d="M158.081,83.3c0,10.839,0,59.218,0,59.218h-43.385v72.412h43.385v215.183h89.122V214.936h59.805
            c0,0,5.601-34.721,8.316-72.685c-7.784,0-67.784,0-67.784,0s0-42.127,0-49.511c0-7.4,9.717-17.354,19.321-17.354
            c9.586,0,29.818,0,48.557,0c0-9.859,0-43.924,0-75.385c-25.016,0-53.476,0-66.021,0C155.878-0.004,158.081,72.48,158.081,83.3z" /></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g>
        </g><g></g><g></g><g></g><g></g><g></g><g></g></svg>
                        </a>
                        <div class="from-fls">
                          <mat-form-field>
                            <input matInput type="text" class="example-right-align" formControlName="FacebookUrl">
                            <span matPrefix>https://www.facebook.com/ </span>
                            <span matSuffix></span>
                          </mat-form-field>
                        </div>
                      </li>
                      <li class="twtclr">
                        <a href="javascript:void(0);">
                          <svg width="20" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512.002 512.002" style="enable-background:new 0 0 512.002 512.002;" xml:space="preserve">
                          <g>
                          <path d="M512.002,97.211c-18.84,8.354-39.082,14.001-60.33,16.54c21.686-13,38.342-33.585,46.186-58.115
            c-20.299,12.039-42.777,20.78-66.705,25.49c-19.16-20.415-46.461-33.17-76.674-33.17c-58.011,0-105.042,47.029-105.042,105.039
            c0,8.233,0.929,16.25,2.72,23.939c-87.3-4.382-164.701-46.2-216.509-109.753c-9.042,15.514-14.223,33.558-14.223,52.809
            c0,36.444,18.544,68.596,46.73,87.433c-17.219-0.546-33.416-5.271-47.577-13.139c-0.01,0.438-0.01,0.878-0.01,1.321
            c0,50.894,36.209,93.348,84.261,103c-8.813,2.399-18.094,3.687-27.674,3.687c-6.769,0-13.349-0.66-19.764-1.888
            c13.368,41.73,52.16,72.104,98.126,72.949c-35.95,28.176-81.243,44.967-130.458,44.967c-8.479,0-16.84-0.496-25.058-1.471
            c46.486,29.807,101.701,47.197,161.021,47.197c193.211,0,298.868-160.062,298.868-298.872c0-4.554-0.104-9.084-0.305-13.59
            C480.111,136.775,497.92,118.275,512.002,97.211z" />
        </g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g>
                          <g></g></svg>
                        </a>
                        <div class="from-fls">
                          <mat-form-field>
                            <input matInput type="text" class="example-right-align" formControlName="TwitterUrl">
                            <span matPrefix>https://twitter.com/ </span>
                            <span matSuffix></span>
                          </mat-form-field>
                        </div>
                      </li>

                      <li class="instaclr">
                        <a href="javascript:void(0);">
                          <svg width="20" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                          <g> <g>   <path d="M373.659,0H138.341C62.06,0,0,62.06,0,138.341v235.318C0,449.94,62.06,512,138.341,512h235.318
              C449.94,512,512,449.94,512,373.659V138.341C512,62.06,449.94,0,373.659,0z M470.636,373.659
              c0,53.473-43.503,96.977-96.977,96.977H138.341c-53.473,0-96.977-43.503-96.977-96.977V138.341
              c0-53.473,43.503-96.977,96.977-96.977h235.318c53.473,0,96.977,43.503,96.977,96.977V373.659z" />
          </g></g><g> <g>
                          <path d="M370.586,238.141c-3.64-24.547-14.839-46.795-32.386-64.342c-17.547-17.546-39.795-28.746-64.341-32.385
              c-11.176-1.657-22.507-1.657-33.682,0c-30.336,4.499-57.103,20.541-75.372,45.172c-18.269,24.631-25.854,54.903-21.355,85.237
              c4.499,30.335,20.541,57.102,45.172,75.372c19.996,14.831,43.706,22.619,68.153,22.619c5.667,0,11.375-0.418,17.083-1.265
              c30.336-4.499,57.103-20.541,75.372-45.172C367.5,298.747,375.085,268.476,370.586,238.141z M267.791,327.632
              c-19.405,2.882-38.77-1.973-54.527-13.66c-15.757-11.687-26.019-28.811-28.896-48.216c-2.878-19.405,1.973-38.77,13.66-54.527
              c11.688-15.757,28.811-26.019,48.217-28.897c3.574-0.53,7.173-0.795,10.772-0.795s7.199,0.265,10.773,0.796
              c32.231,4.779,57.098,29.645,61.878,61.877C335.608,284.268,307.851,321.692,267.791,327.632z" />
          </g></g><g> <g>
                          <path d="M400.049,111.951c-3.852-3.851-9.183-6.058-14.625-6.058c-5.442,0-10.773,2.206-14.625,6.058
              c-3.851,3.852-6.058,9.174-6.058,14.625c0,5.451,2.207,10.773,6.058,14.625c3.852,3.851,9.183,6.058,14.625,6.058
              c5.442,0,10.773-2.206,14.625-6.058c3.851-3.852,6.058-9.183,6.058-14.625C406.107,121.133,403.9,115.802,400.049,111.951z" />
          </g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g>
        </g><g></g><g></g><g></g></svg>

                        </a>
                        <div class="from-fls">
                          <mat-form-field>
                            <input matInput type="text" class="example-right-align" formControlName="InstagramUrl">
                            <span matPrefix>https://www.instagram.com/ </span>
                            <span matSuffix></span>
                          </mat-form-field>
                        </div>
                      </li>
                      <li class="yutubeclr">
                        <a href="javascript:void(0);">
                          <svg width="20" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 508.492 508.492" style="enable-background:new 0 0 508.492 508.492;" xml:space="preserve">
                          <path style="fill:#010002;" d="M504.15,158.24c-2.829-33.848-23.011-76.532-64.487-78.058c-115.815-7.787-253.02-9.916-370.933,0
          c-36.582,4.1-61.658,48.659-64.391,82.507c-5.784,71.097-5.784,111.557,0,182.654c2.765,33.848,27.206,78.662,64.455,83.365
          c119.311,7.787,255.849,8.899,370.933,0c36.105-6.261,61.69-49.517,64.455-83.365C509.934,274.214,509.934,229.337,504.15,158.24z
          M190.647,344.199V161.926l158.912,91.152L190.647,344.199z" />
                        <g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g>
        </g><g></g><g></g><g></g><g></g></svg>
                        </a>
                        <div class="from-fls">
                          <mat-form-field>
                            <input matInput type="text" class="example-right-align" formControlName="YouTubeUrl">
                            <span matPrefix>https://www.youtube.com/ </span>
                            <span matSuffix></span>
                          </mat-form-field>
                        </div>
                      </li>
                    </ul>

                  </mat-card-content>
                </mat-card>
              </div>
              <div class="col-lg-6 mat-crd-ui">
                <mat-card>
                  <mat-card-title>
                    <h5 class="page-title">
                      Store Status
                    </h5>
                  </mat-card-title>
                  <mat-card-content>
                    <mat-nav-list>
                      <mat-list-item class="mat-list-item-content">
                        <div class="mat-list-text w-100">
                          <p matLine href="...">Online</p>  
                        </div>
                        <mat-slide-toggle formControlName="IsActive" (click)="ShowNotification();" style="padding-top: 5px;"></mat-slide-toggle>
                      </mat-list-item>
                      <mat-list-item *ngIf="showNotification">
                        <p matLine href="...">
                          <em class="enbl-blk-in">
                            Bringing store online requires W9 details.
                            To fill in details please <a style="font-weight: bold;" [routerLink]="[ '/store/W9Form']">Click here...</a>
                          </em>
                        </p>
                      </mat-list-item>
                      <mat-list-item>
                        <p matLine href="...">
                          <em class="enbl-blk-in">Online means Store will be visible to the customers.</em>
                        </p>
                      </mat-list-item>
                      <!--<mat-list-item>
                        <p matLine href="...">
                          Customize Products
                          <em class="enbl-blk-in">enable/disable feature for end user to customize products</em>
                        </p>
                        <mat-slide-toggle formControlName="CanEndUserCustomize"></mat-slide-toggle>
                      </mat-list-item>-->
                    </mat-nav-list>
                  </mat-card-content>
                </mat-card>
              </div>
            </div>
          </div>
        </div>
        <div class="text-right">
          <button class="mat-btn btn-danger" mat-button (click)="UpdateStore(editStoreForm)">Save</button>
        </div>
        <br />
        <br />
        <br />
      </form>
    </div>
  </div>
</main>
